<template>
	<div class="flexContainer">
		<div class="wrapper">
			<div class="headerTitle">
				Wand-Projektion {{wallTitle}}
			</div>
			<div class="imgWrapper">
				<div class="image" v-if="wallIsImage"
					 v-bind:style="{ backgroundImage: 'url(' + wallUrl + ')'}">
				</div>

				<div class="video" v-if="!wallIsImage">
					<video id="wallVideo" v-bind:src="wallUrl"/>
					<div v-if="!isPlayingWall" class="videoButton" v-on:click="playWall">
						<IconBase class="icon"
								  iconName="pencil"
								  width="120"
								  height="120"
								  viewBox="0 0 512 512">
							<IconPlay/>
						</IconBase>
					</div>
					<div v-if="isPlayingWall" class="videoButton" v-on:click="stopWall">
						<IconBase class="icon"
								  iconName="pencil"
								  width="120"
								  height="120"
								  viewBox="0 0 512 512">
							<IconPause/>
						</IconBase>
					</div>
				</div>
			</div>
		</div>

		<div class="wrapper">
			<div class="empty"></div>
			<div class="textWrapper">
				<div v-if="step.title" class="stepTitle">{{step.title}}</div>
				<div class="stepText" v-html="step.text"></div>
			</div>
		</div>

		<div class="wrapper"
			 v-bind:class="{paintMode: isPaintMode}">
			<div class="headerTitle"
				 v-bind:class="{hide: isPaintMode}">
				Modell-Projektion {{modelTitle}}
				<div class="fullscreen"
					 v-bind:class="{show: !isPaintMode}"
					 v-on:click.stop.prevent="togglePaintMode()">
					<IconBase class="icon"
							  iconName="pencil"
							  width="20"
							  height="20"
							  viewBox="0 0 298.667 298.667">
						<IconFullScreen/>
					</IconBase>
				</div>
			</div>
			<div class="imgWrapper">
				<div class="image"
					 v-if="!isPaintMode && modelIsImage"
					 v-bind:class="{imgBig: isPaintMode}"
					 v-bind:style="{ backgroundImage: 'url(' + modelUrl + ')'}">
				</div>

				<div class="video" v-if="!modelIsImage">
					<video v-if="!isPaintMode" id="modelVideo" v-bind:src="modelUrl"/>
					<div v-if="!isPlaying && !isPaintMode" class="videoButton" v-on:click="playModel">
						<IconBase class="icon"
								  iconName="pencil"
								  width="120"
								  height="120"
								  viewBox="0 0 512 512">
							<IconPlay/>
						</IconBase>
					</div>
					<div v-if="isPlaying && !isPaintMode" class="videoButton" v-on:click="stopModel">
						<IconBase class="icon"
								  iconName="pencil"
								  width="120"
								  height="120"
								  viewBox="0 0 512 512">
							<IconPause/>
						</IconBase>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import IconBase from '@/components/icons/IconBase.vue';import IconPlay from '@/components/icons/IconPlay.vue';
	import IconPause from '@/components/icons/IconPause.vue';
	import {EventBus} from '@/services/EventBus.js';

	export default {
		name: "PreviewStep",
		props: ["step"],
		components: {
			IconBase,
			IconPlay,
			IconPause
		},
		methods: {
			playWall() {
				this.isPlayingWall = true;
				document.getElementById('wallVideo').play();
			},
			playModel() {
				this.isPlaying = true;
				document.getElementById('modelVideo').play();
			},
			stopWall() {
				this.isPlayingWall = false;
				document.getElementById('wallVideo').pause();
			},
			stopModel() {
				this.isPlaying = false;
				document.getElementById('modelVideo').pause();
			},
			getTitle(slide, length) {
				let title = '- ' + slide.title.substr(0, length);
				if (slide.title.length >= length) title = title.concat("\u2026");

				return title;
			}
		},
		data() {
			return {
				isPaintMode: false,
				modelIsImage: true,
				wallIsImage: true,
				modelUrl: '',
				wallUrl: '',
				isPlaying: false,
				isPlayingWall: false,
				modelTitle: '',
				wallTitle: '',
				currentStepId: '',
			}
		},
		created() {
			EventBus.$on('onStop', () => {
				this.isPlaying = false;
			});
		},
		updated() {
			if(this.step.id === this.currentStepId) return;
			this.currentStepId = this.step.id;

			this.wallTitle = '';
			if (this.step.wall_slide) {
				this.wallTitle = this.getTitle(this.step.wall_slide, 20);
				if (this.step.wall_slide.media.mime.includes('video')) {
					this.wallIsImage = false;
					this.wallUrl = process.env.VUE_APP_BASE_URL + this.step.wall_slide.media.url + '#t=5';
				} else {
					this.wallIsImage = true;
					this.wallUrl = process.env.VUE_APP_BASE_URL + this.step.wall_slide.media.formats.large.url;
				}
			} else {
				this.wallIsImage = true;
				this.wallUrl = '';
			}

			this.modelTitle = '';
			if (this.step.model_slide) {
				this.modelTitle = this.getTitle(this.step.model_slide, 16);
				if (this.step.model_slide.media.mime.includes('video')) {
					this.modelIsImage = false;
					this.modelUrl = process.env.VUE_APP_BASE_URL + this.step.model_slide.media.url + '#t=5';
				} else {
					this.modelIsImage = true;
					console.log(this.step.model_slide.media.formats);
					this.modelUrl = process.env.VUE_APP_BASE_URL + this.step.model_slide.media.formats.large.url;
				}
			} else {
				this.modelIsImage = true;
				this.modelUrl = '';
			}
		}
	}
</script>

<style scoped>
	.image {
		background-position: center;
		background-repeat: no-repeat;
		background-size: contain;
		height: 100%;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		transform: scale(1);
		position: relative;
	}

	.wrapper.paintMode {
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.5);
		z-index: 99;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.imgWrapper {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: black;
		border-left: 1px solid white;
		position: relative;
	}

	.fullscreen {
		display: none;
	}

	.minimize {
		position: absolute;
		top: 10px;
		right: 10px;
		display: none;
		z-index: 99;
	}

	.drawCanvas {
		display: none;
	}

	.fullscreen.show,
	.minimize.show {
		display: block;
	}

	.minimize svg {
		background: none;
	}

	.minimize svg g {
		fill: white;
	}

	.stepTitle {
		font-family: "BrownLLWeb-Bold";
		font-style: bold;
		font-size: 25px;
		padding: 15px 10px 5px 10px;
	}

	.stepText {
		font-family: "BrownLLWeb-Regular";
		font-style: normal;
		font-size: 20px;
		padding: 5px 10px 5px 10px;
		overflow-x: scroll;
		max-height: 336px;
	}

	.headerTitle {
		font-family: "BrownLLWeb-Regular", Helvetica, sans-serif;
		font-weight: normal;
		font-size: 20px;
		border-bottom: black solid 1px;
		padding: 5px 10px 5px 10px;
		display: flex;
		justify-content: space-between;
	}

	.empty {
		border-bottom: black solid 1px;
	}

	.flexContainer .navBox {
		min-width: 280px;
		max-width: 400px;
		height: 435px;
		padding-bottom: 0px;
	}

	.textWrapper {
		overflow-y: auto;
		width: 100%;
		height: 100%;
		border-left: 1px solid white;
	}

	::-webkit-scrollbar-track {
		background: #fff;
		border: 1px solid white;
	}

	::-webkit-scrollbar-thumb {
		border: 1px solid white;
	}

	.wrapper {
		display: flex;
		flex-direction: column;
		flex: 1 0 0;
		justify-content: flex-start;
		border-left: black solid 1px;
		border-top: black solid 1px;
		border-bottom: black solid 1px;
	}

	.hide {
		display: none;
	}

	.imgBig {
		width: 100%;
	}

	video {
		width: 100%;
	}

	.video {
		width: 100%;
		position: relative;
	}

	.videoButton {
		position: absolute;
		left: 50%;
		margin-left: -60px;
		top: 50%;
		margin-top: -60px;
	}

	.video svg {
		border-radius: 67px;
		background-color: rgba(0,0,0,0.6);
	}

	.video svg g {
		stroke: white;
		fill: white;
	}
</style>